/**
 * Created by mh on 2017/5/28.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import TimelineModel from './model/TimelineModel';

const TypeToColorClass = (type) => {
    switch (type) {
    case 'music-playout':
        return 'badge-primary';
    case 'music-schedule':
        return 'badge-info';
    default:
        return 'badge-secondary';
    }
};

const TypeBadge = type => <span className={`badge ${TypeToColorClass(type)}`}>{type}</span>;

@observer
export default class TimelineTableRow extends React.Component {
    render() {
        const { timeline } = this.props;
        return (
            <tr>
                <td className="align-middle">
                    {TypeBadge(timeline.layerId)}
                </td>
                <td className="align-middle">{timeline.blockId}</td>
                <td className="align-middle">
                    <Link className="" to={`details/${timeline.id}/`}>
                        {timeline.name}
                    </Link>
                </td>
                <td className="align-middle">
                    <Link className="btn btn-sm btn-secondary" to={`details/${timeline.id}/`}>+</Link>
                </td>
            </tr>);
    }
}
TimelineTableRow.propTypes = {
    timeline: PropTypes.instanceOf(TimelineModel).isRequired,
};
